var InitStockReceiptTypeSelectingModal = function (BackOffice, $) {
    BackOffice.StockReceiptTypeSelectingModal = (function () {
        const ModalSelector = '#stockReceiptTypeSelectingModal'
        const POIDDivSelector = '#POIDInputDiv'
        var POIDInputSelector = '#StockReceiptTypeSelectionModalPOID'
        var ContinueBtnSelector = '#btnContinue'

        var openModal = function (openCallbackFn, closedCallbackFn, hidePOIDInput) {
            self.OpenCallBackFn = openCallbackFn;
            self.CloseCallBackFn = closedCallbackFn;
            if (hidePOIDInput) {
                $(POIDDivSelector).hide();
            }
            $(ModalSelector).modal('show');
        }

        var isValid = function () {
            if ($(POIDDivSelector).is(":hidden")) {
                return true;
            }
            var poid = $(POIDInputSelector).val();
            if (!poid) {
                $('#POIDRequiredValidationMessage').addClass('active');
                return false;
            }
            var result = true;
            BackOffice.ToggleLoader(true);
            $.ajax({
                data: { POId: poid },
                url: window.location.origin + '/dotnet/admin/api/getposummary',
                async: false,
                dataType: 'json',
                contentType: 'application/json charset=UTF-8',
                success: function (model) {
                    result = true;
                },
                error: function () {
                    $('#POIDInvalidValidationMessage').addClass('active');
                    result = false;
                }
            });
            BackOffice.ToggleLoader(false);
            return result;
        }

        $(ModalSelector).on("shown.bs.modal", function () {
            if (self.OpenCallBackFn) {
                self.OpenCallBackFn();
            }
        });

        $(ModalSelector).on("hidden.bs.modal", function () {
            if (self.CloseCallBackFn) {
                self.CloseCallBackFn();
            }
            $('.modal-backdrop').remove();
        });

        $(POIDInputSelector).keydown(function (event) {
            // reset validation messages
            $('#POIDRequiredValidationMessage').removeClass('active');
            $('#POIDInvalidValidationMessage').removeClass('active');
            if (event.keyCode === 13) {
                $(ContinueBtnSelector).click();
            }
        });

        var closeModal = function () {
            $('.modal-backdrop').remove();
            $(ModalSelector).modal('hide');
        }

        return $.extend(BackOffice.StockReceiptTypeSelectingModal, {
            OpenModal: openModal,
            CloseModal: closeModal,
            IsValid: isValid,
            POIDInputSelector: POIDInputSelector
        })
    })()

    return BackOffice.StockReceiptTypeSelectingModal
}